module.exports = __webpack_public_path__ + "images/emoji/dizzy.17b9eaff1150105036a0.png";